import React, {useEffect, useState} from "react";
// import {useHistory} from "react-router-dom";

// import "../styles/footer.css"
import styles from "../styles/module/layout.module.css"
import stylesFooter from "../styles/module/Footer.module.css"
import {Link, Route, useLocation, useNavigate} from "react-router-dom";
import {
    addressExport, emailExport,
    facebookLink,
    googleMapsLink,
    instagramLink,
    linkLogo,
    linkLogoWhite,
    phoneExport,
    tiktokLink, timeExport
} from "./layout/Header.jsx";
import { smoothScrollToId} from "../utils/helper.jsx";
import stylesHeader from "../styles/module/Header.module.css";
import {CiClock2} from "react-icons/ci";
export function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}



const Footer = ({textColor = ""}) => {
    const [activeLink, setActiveLink] = useState('');
    const navigate = useNavigate();  // Khởi tạo hook useNavigate
    const location = useLocation();
    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);

    const menus = [
        {
            label: "StartSeite",
            url: "/"
        },
        {
            label: "Speisekarte",
            url: "/menu"
        },
        {
            label: "Über uns",
            url: "#",
            id: 'about-us',
            nonRedirect: true,
        },

        {
            label: "Tisch reservieren",
            url: "/booking",
        },

        {
            label: "Kontaktieren Sie uns",
            url: "/kontaktieren-sie-uns"
        },

    ]
    const menusSocial = [
        {
            label: "Facebook",
            url: facebookLink
        },
        {
            label: "Instagram",
            url: instagramLink
        },
        {
            label: "Tiktok",
            url: tiktokLink
        },
        {
            label: "Google Map",
            url: googleMapsLink
        },
    ]
const handleClick = () =>{
    navigate("/booking")
}

    return (

        <>
            <iframe className={styles.iframeAddress}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2492.4249842777144!2d12.377873600000001!3d51.340095399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a6f9469fb80e1b%3A0xe779f52bcab0030e!2sZenchi%20Asian%20Restaurant%20Leipzig!5e0!3m2!1svi!2s!4v1762782228257!5m2!1svi!2s"
                    width="600" height="450" allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            <footer className={`${stylesFooter.footer} ${stylesFooter.section} ${styles["has-bg-image"]} ${stylesFooter.textCenter}  `}>
                <div className={stylesFooter.overShadow}></div>
                <div className={stylesFooter.containerFooter}>
                    <div className={`footer-top ${stylesFooter.gridList}`}>
                        <ul className={stylesFooter.footerList}>
                            {menus?.map(({ label, url, nonRedirect, id, target }, index) => (
                                <li key={index}>
                                    <div
                                        onClick={() => {
                                            if (target) {
                                                window.open(url, target);
                                            } else if (nonRedirect) {
                                                smoothScrollToId(id, 'start', 'nearest', navigate);
                                            } else {
                                                navigate(url);
                                            }
                                        }}
                                        className={`${styles.navbarLink} ${styles.hoverUnderline} ${
                                            activeLink === url ? styles.active : ''
                                        }`}
                                    >
                                        {label}
                                    </div>
                                </li>
                            ))}
                        </ul>

                        <div className={`footer-brand has-before has-after ${stylesFooter.footerBrand}`}>
                            <Link to="/" className={stylesFooter.footerLogo}>
                                <img src={linkLogoWhite} alt="" />
                            </Link>

                            <a
                                href={googleMapsLink}
                                className={`${stylesFooter.body4} ${stylesFooter.contactLink}`}
                            >
                                <strong className={stylesFooter.textColorGold}>{addressExport}</strong>
                            </a>

                            <a
                                href={`mailto:${emailExport}`}
                                className={`${stylesFooter.body4} ${stylesFooter.contactLink}`}
                            >
                                <strong className={stylesFooter.textColorGold}>{emailExport}</strong>
                            </a>

                            <a href={`tel:+${phoneExport}`} className={`${stylesFooter.body4} ${stylesFooter.contactLink}`}>
                                Besuchen Sie uns: <strong className={stylesFooter.textColorGold}>+{phoneExport}</strong>
                            </a>

                            <p className={stylesFooter.body4}>
                                <div className={stylesHeader.stuff}>
                                    <CiClock2/>
                                    <strong className={stylesFooter.textColorGold}>{timeExport}</strong>
                                </div>
                            </p>

                            <p className={stylesFooter.title1}>Bleib über Neuigkeiten und Angebote informiert</p>

                            <p className={stylesFooter.label1}>
                                Abonnieren Sie uns und erhalten Sie{' '}
                                <strong className={stylesFooter.textColorGold}>Werbeinformationen</strong>
                            </p>

                            <div className="wrap-btn-custom">
                                <button className="hover-filled-slide-right" onClick={handleClick}>
                                    <span>Tisch reservieren</span>
                                </button>
                            </div>
                        </div>

                        <ul className={stylesFooter.footerList}>
                            {menusSocial?.map(({ label, url }, index) => (
                                <li key={index}>
                                    <Link
                                        to={url}
                                        target="_blank"
                                        className={`${styles.navbarLink} ${styles.hoverUnderline} ${
                                            activeLink === url ? styles.active : ''
                                        }`}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className={stylesFooter.footerBottom}>
                        <div className={stylesFooter.copyright}>
                            &copy; 2025 Kando. All{' '}
                            <Link className="link" to="/Impressum">
                                Impressum
                            </Link>{' '}
                            |{' '}
                            <Link className="link" to="/Datenschutz">
                                Datenschutz
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </>


    )
}
export default Footer